/**
 * Toggles the chevron icons in the comments section of the page.
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  toggle(event) {
    event.preventDefault();
    event.target
      .closest("span")
      .querySelectorAll("svg")
      .forEach((svg) => {
        svg.classList.toggle("d-none");
      });
  }
}
